export default __webpack_public_path__ + "static/media/google-play.e5020c9a.png";